import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage(): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="app-shell py-16 text-center">
      <h1 className="text-2xl font-bold text-fog-100">{t('common.notFound')}</h1>
      <p className="mt-2 text-fog-500">{t('common.notFoundBody')}</p>
      <Link
        to="/"
        className="mt-6 inline-block rounded-full bg-primary px-6 py-3 font-semibold text-white"
      >
        {t('common.backHome')}
      </Link>
    </div>
  );
}
